import { render, staticRenderFns } from "./IndicatorWizardStep4.vue?vue&type=template&id=6297f6db&scoped=true&"
import script from "./IndicatorWizardStep4.vue?vue&type=script&lang=js&"
export * from "./IndicatorWizardStep4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6297f6db",
  null
  
)

export default component.exports